/**
 * V70G8J — 오목 로비 복귀 참조 (localStorage omok.lastRoomId)
 *   서버의 진행 중 대국 판정(omokActivePlayers)은 status==='playing' 인 방만 인정하므로,
 *   승패가 확정된 방에 남는 "참여 상태"는 이 클라이언트 참조뿐이다. 이 모듈에서 저장·정리한다.
 *   (V70G6B 의 save/loadLastRoomId 를 옮겨 왔고 useOmokRoom 에서 그대로 re-export)
 */
const LS_KEY_LAST_ROOM = 'omok.lastRoomId';

export function saveLastRoomId(roomId: string | null): void {
  try {
    if (roomId) window.localStorage.setItem(LS_KEY_LAST_ROOM, roomId);
    else window.localStorage.removeItem(LS_KEY_LAST_ROOM);
  } catch { /* ignore */ }
}
export function loadLastRoomId(): string | null {
  try {
    return window.localStorage.getItem(LS_KEY_LAST_ROOM);
  } catch { return null; }
}

/** 복귀 대상이 아닌(승패 확정·폐기) 방 상태 */
export function isOmokRoomEnded(status: unknown): boolean {
  return status === 'finished' || status === 'abandoned';
}

/** 저장된 복귀 방이 이 방일 때만 지운다 (다른 탭에서 새 방에 들어갔으면 유지) */
export function clearLastRoomIdIf(roomId: string): void {
  if (loadLastRoomId() === roomId) saveLastRoomId(null);
}
